'use client';

import type { ConvertedBannerSwiperWidgetData } from '@weberus/shared-types/src/display/widgets/brand-swipe';
import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import { SubHeader } from '@yanolja-rnd/nol-design-system';
import { clientLogBy } from '@weberus/client-tracker';
import { ShowAllButton } from 'app/_components/common/show-all-button';
import { BrandSwipeList } from './brand-swipe-list/brand-swipe-list';

export interface BrandSwipeProps {
  data: ConvertedBannerSwiperWidgetData;
  pageNameLog: HomeLogPageNameValue;
}

/** 위젯 브랜드관 */
export function BrandSwipe({ data, pageNameLog }: BrandSwipeProps) {
  const { header, items, seeMore, logMeta: widgetLogMeta } = data;

  return (
    <section className="my-16 w-full pc:my-40 pc:w-pc-size">
      {!!header && <SubHeader className="px-16" subTitle={header.subTitle} title={header.title} />}
      <BrandSwipeList items={items} pageNameLog={pageNameLog} widgetLogMeta={widgetLogMeta} />
      <ShowAllButton
        boldTitle={seeMore.buttonTextBold}
        title={seeMore.buttonTextNormal}
        href={seeMore.linkUrl}
        onClick={() => clientLogBy('click', pageNameLog, seeMore.logMeta)}
      />
    </section>
  );
}
